import JoyRide, { STATUS } from 'react-joyride';
import '../assets/styles/tour.scss';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { endTour } from '../actions';

// This is for non-members
const TOUR_STEPS_AO = [
  {
    target: '.main-content',
    title: (
      <>
        <span>Welcome to HiveDesk</span>
        <span className="badge bg-primary-soft">1/6</span>
      </>
    ),
    content: (
      <p>
        This tour will show you how to access the key features of HiveDesk -
        Let's go!
      </p>
    ),
    placement: 'center',
    hideCloseButton: true,
    disableOverlayClose: true,
  },

  {
    target: '.nav-projects',
    title: (
      <>
        <span>View, Create, and Manage Projects</span>
        <span className="badge bg-primary-soft">2/6</span>
      </>
    ),
    content: (
      <>
        <p>
          Access project features of HiveDesk via Projects {'>'} Active. From
          here, you can:
        </p>
        <ul>
          <li>Create new projects</li>
          <li>Invite team members</li>
          <li>Assign tasks</li>
          <li>View work sessions</li>
        </ul>
      </>
    ),
    placement: 'right',
    disableBeacon: true,
    hideCloseButton: true,
    spotlightPadding: 0,
    offset: 0,
    disableOverlayClose: true,
  },
  {
    target: '.nav-team',
    title: (
      <>
        <span>Add, Delete, and Review Team Members</span>
        <span className="badge bg-primary-soft">3/6</span>
      </>
    ),
    content: (
      <>
        <p>View Team Member data from Team {'>'} Active. You can:</p>
        <ul>
          <li>View team member info</li>
          <li>Add team member</li>
          <li>Email or download work sessions of team members</li>
        </ul>
      </>
    ),
    placement: 'right',
    disableBeacon: true,
    hideCloseButton: true,
    spotlightPadding: 0,
    offset: 0,
    disableOverlayClose: true,
  },
  {
    target: '.nav-timesheet',
    title: (
      <>
        <span>Generate and Email Reports</span>
        <span className="badge bg-primary-soft">4/6</span>
      </>
    ),
    content: (
      <>
        <p>
          Gain insight into team member activity via Reports. Reports currently
          supported include
        </p>
        <ul>
          <li>Timesheet reports</li>
          <li>Work session charts</li>
          <li>Daily work summaries</li>
          <li>Weekly reports</li>
          <li>Screenshot reports</li>
        </ul>
        <p>Create reports and email them to yourself and/or others.</p>
      </>
    ),
    placement: 'right',
    disableBeacon: true,
    hideCloseButton: true,
    spotlightPadding: 0,
    offset: 0,
    disableOverlayClose: true,
  },
  {
    target: '.nav-activity',
    title: (
      <>
        <span>View Team Members Activity</span>
        <span className="badge bg-primary-soft">5/6</span>
      </>
    ),
    content: <p>Review your team members activity here.</p>,
    placement: 'right',
    disableBeacon: true,
    hideCloseButton: true,
    spotlightPadding: 0,
    offset: 0,
    disableOverlayClose: true,
  },
  {
    target: '.main-content',
    title: (
      <>
        <span>Get Started</span>
        <span className="badge bg-primary-soft">6/6</span>
      </>
    ),
    content: (
      <p>
        If you would like to start the tour again, go to{' '}
        <i className="mdi mdi-map-outline" /> on the top right of the page.
        <br />
        If you have questions or need help, go to{' '}
        <i className="mdi mdi-help-circle-outline" /> on the top right of the
        page.
      </p>
    ),
    placement: 'center',

    hideCloseButton: true,
    disableOverlayClose: true,
  },
];
// This is for team members
const TOUR_STEPS_TM = [
  {
    target: '.main-content',
    title: (
      <>
        <span>Welcome to HiveDesk</span>
        <span className="badge bg-primary-soft">1/6</span>
      </>
    ),
    content: (
      <p>
        This tour will show you how to access the key features of HiveDesk -
        Let's go!
      </p>
    ),
    placement: 'center',
    hideCloseButton: true,
    disableOverlayClose: true,
  },

  {
    target: '.nav-projects',
    title: (
      <>
        <span>Accept the Project Invitation</span>
        <span className="badge bg-primary-soft">2/6</span>
      </>
    ),
    content: (
      <>
        <p>
          You can accept invitation for a project by clicking an Accept
          invitation button. After accepting, you will be a Team Member of this
          project.
        </p>
      </>
    ),
    placement: 'right',
    disableBeacon: true,
    hideCloseButton: true,
    spotlightPadding: 0,
    offset: 0,
    disableOverlayClose: true,
  },
  {
    target: '.main-content',
    title: (
      <>
        <span>Download the HiveDesk Client</span>
        <span className="badge bg-primary-soft">3/6</span>
      </>
    ),
    content: (
      <>
        <p>
          Download the HiveDesk client - You can choose your HiveDesk client
          based on your operating system. <br />
          Use the same username and password to connect to the HiveDesk client
          that you did to log into the web interface
        </p>
      </>
    ),
    placement: 'center',
    disableBeacon: true,
    hideCloseButton: true,
    spotlightPadding: 0,
    offset: 0,
    disableOverlayClose: true,
  },
  {
    target: '.main-content',
    title: (
      <>
        <span>Start Working with HiveDesk Client</span>
        <span className="badge bg-primary-soft">4/6</span>
      </>
    ),
    content: (
      <>
        <p>
          After login, select the project you want to work on from the project
          list and click the Check In button.
          <br />
          From there, you can see your tasks in the task list. Mark tasks as
          completed as they are finished.
        </p>
      </>
    ),
    placement: 'center',
    disableBeacon: true,
    hideCloseButton: true,
    spotlightPadding: 0,
    offset: 0,
    disableOverlayClose: true,
  },
  {
    target: '.nav-projects',
    title: (
      <>
        <span>Reading Project Notes</span>
        <span className="badge bg-primary-soft">5/6</span>
      </>
    ),
    content: (
      <p>
        If the Project Creator has posted any Project Notes, you can view them
        after logging into the HiveDesk client.
      </p>
    ),
    placement: 'right',
    disableBeacon: true,
    hideCloseButton: true,
    spotlightPadding: 0,
    offset: 0,
    disableOverlayClose: true,
  },
  {
    target: '.main-content',
    title: (
      <>
        <span>Get Started</span>
        <span className="badge bg-primary-soft">6/6</span>
      </>
    ),
    content: (
      <p>
        If you would like to start the tour again, go to{' '}
        <i className="mdi mdi-map-outline" /> on the top right of the page.
        <br />
        If you have questions or need help, go to{' '}
        <i className="mdi mdi-help-circle-outline" /> on the top right of the
        page.
      </p>
    ),
    placement: 'center',
    hideCloseButton: true,
    disableOverlayClose: true,
  },
];

// Tour component
const Tour = ({ start }) => {
  const userDetails = useSelector((state) => state.userReducer);

  const dispatch = useDispatch();

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if ([STATUS.SKIPPED].includes(status)) {
      dispatch(endTour());
    }
  };

  return (
    <JoyRide
      steps={userDetails.role === 'member' ? TOUR_STEPS_TM : TOUR_STEPS_AO}
      callback={handleJoyrideCallback}
      run={start}
      continuous
      showSkipButton
      locale={{
        last: 'Close',
        skip: 'Close',
        back: 'Previous',
      }}
      styles={{
        options: {
          zIndex: 10000,
          width: 600,
          primaryColor: '#0649b5',
          textColor: '#12263f',
          overlayColor: 'rgba(49, 58, 70, 0.7)',
        },
        tooltip: {
          borderRadius: 7,
          padding: 0,
        },
        tooltipContainer: {
          textAlign: 'left',
        },
        tooltipTitle: {
          fontSize: 15,
          margin: '5px 0 15px',
          padding: '20px 20px 0',
          display: 'flex',
          justifyContent: 'space-between',
        },
        tooltipContent: {
          fontSize: 14,
          padding: '20px 20px 5px',
          borderTop: '1px solid #edf2f9',
          borderBottom: '1px solid #edf2f9',
        },
        tooltipFooter: {
          padding: '20px',
          marginTop: 0,
        },
        buttonSkip: {
          backgroundColor: '#edf2f9',
          borderRadius: '4px',
          color: '#283e59',
        },
      }}
    />
  );
};

Tour.propTypes = {
  start: PropTypes.any,
};

export default Tour;
